import React, { Component } from 'react';
import PropTypes from 'prop-types';
class UploadCsvPreview extends Component {
  static propTypes = {
    csvData: PropTypes.array.isRequired,
    csvHeader: PropTypes.array.isRequired,
  };

  render() {
    const { csvData, csvHeader } = this.props;
    return (
      <div className="row">
        <div className="col-md-12 text-center">
          <h2>Imported CSV Content</h2>
        </div>
        <div className="col-md-12 table-responsive csv-preview-table">
          <table className="table table-bordered table-hover table-sm table-word-break">
            <thead>
              <tr>
                {Object.keys(csvHeader).map((key, index) => (
                  <th key={key}>{csvHeader[index]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.keys(csvData).map((key, dataIndex) => (
                <tr key={key}>
                  {Object.keys(csvHeader).map((key, index) => (
                    <td key={key}>{csvData[dataIndex].data[csvHeader[index]]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UploadCsvPreview;
